import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"min-width":"1920px","width":"100%"} }
const _hoisted_2 = { class: "content-wrap" }

import { ref, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import TopBar from "@/components/TopBar.vue";
import SideBar from "@/components/SideBar.vue";
import Loading from "@/components/Loading.vue";
import { USER_ROUTES } from "@/assets/route_constants";
import { useAuth } from "@/composables/useAuth";


export default /*@__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const { loading, isLoggedIn } = useAuth();
const router = useRouter();
const route = useRoute();

const componentKey = ref(0); // To force re-render if needed

onMounted(() => {
    const homeBasePath = USER_ROUTES.Home.Path;
    if (route.fullPath === homeBasePath) {
        router.push({ name: USER_ROUTES.DashBoard.Name });
    }
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: "main_div",
    key: componentKey.value
  }, [
    _createVNode(TopBar),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(SideBar),
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(), _createBlock(_component_router_view, {
          key: _ctx.$route.fullPath
        }))
      ])
    ])
  ]))
}
}

})